import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { EMPTY, Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { CategoriaResponse, DataCuidadosResposta, IndicadorResponse } from './data-cuidados.models';

/** GeoJSON simplificado — só o suficiente para o que `echarts.registerMap` precisa. */
export interface UfGeoJson {
  type: string;
  features: {
    type: string;
    properties: Record<string, unknown>;
    geometry: unknown;
  }[];
}

@Injectable({ providedIn: 'root' })
export class DataCuidadosService {
  private readonly http = inject(HttpClient);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly url = `${environment.apiUrl}/data-cuidados`;

  getDimensoes(): Observable<CategoriaResponse[]> {
    if (!this.isBrowser) return EMPTY;
    return this.http.get<CategoriaResponse[]>(`${this.url}/dimensoes`);
  }

  getIndicadores(): Observable<IndicadorResponse[]> {
    if (!this.isBrowser) return EMPTY;
    return this.http.get<IndicadorResponse[]>(`${this.url}/indicadores`);
  }

  getResposta(indicador: string, desagregacao: string): Observable<DataCuidadosResposta> {
    if (!this.isBrowser) return EMPTY;
    return this.http.get<DataCuidadosResposta>(`${this.url}/resposta`, {
      params: { indicador, desagregacao },
    });
  }

  /** GeoJSON do Brasil por UF ou por grande região, usado pelo `echarts.registerMap`. */
  getUfGeoJson(type: 'uf' | 'br' = 'uf'): Observable<UfGeoJson> {
    if (!this.isBrowser) return EMPTY;
    return this.http.get<UfGeoJson>('assets/brazil-states.json').pipe(
      map((entry) => {
        const nameKey = type === 'br' ? 'regiao_id' : 'sigla';
        return {
          ...entry,
          features: entry.features.map((feature) => ({
            ...feature,
            properties: {
              ...feature.properties,
              name: feature.properties[nameKey],
            },
          })),
        };
      }),
    );
  }
}
